import React from 'react';
import { Link } from 'react-router-dom';
import { Button, FormGroup, Col, Row , Table} from 'reactstrap';
import api from '../../api';
import utils from '../../resources/utils';
import Tag from '../../components/Tag';
import './index.css';

const iframeResizerOptions = { checkOrigin: false };

// The Roster component matches one of two different routes
// depending on the full pathname
export default class DatasourceScreen extends React.Component {
    constructor(props) {
        super(props);
        const queries = utils.parseQueryParams(this.props);
        this.state = {
            dashboard: {
                id: parseInt(this.props.match.params.dashboard_id, 10) || '',
                code_name: '',
                description: '',
                name: '',
            },
        }
    }
    componentWillMount() {
        this.getDashboard();
    }
    componentDidMount = () => {
    }
    createMarkup(html_code) {
        return {__html: html_code};
    }
    deleteDashboard() {
        const { dashboard } = this.state;
        const deleteConfirmation = window.confirm(`Are you sure to delete ${dashboard.name || dashboard.code_name}?`);
        if (!deleteConfirmation) return;
        this.setState({ isScanning: true });
        api.fetchAPI({
            method: 'delete',
            uri: `dashboards`,
            body: dashboard,
            success: (response) => {
                if (response.status === 'ok') {
                    this.props.history.push(`/dashboards`);
                } else {
                    alert(response.message);
                }
            },
            error: (error) => {
              console.error(error);
            }
        });
        this.setState({ isScanning: false });
    }
    getDashboard() {
        const { dashboard } = this.state;
        let uri = `dashboard/${dashboard.id}`;
        api.fetchAPI({
            method: 'get',
            uri,
            success: (response) => {
                const dashboard = response.dashboard;
                this.setState({ dashboard });
            },
            error: (error) => {
              console.error(error);
            }
        });
    }
    render() {
        const { dashboard } = this.state;
        if (!dashboard) return null;
        return (
            <div>
                <Row>
                    <Col xs={12}>
                        <h1 className="main-object-code_name">{dashboard.name}</h1>
                        <span className="main-object-type">{dashboard.object_type}</span>
                    </Col>
                    <Col xs={12}>
                        <br/>
                        <p>{dashboard.description}</p>
                    </Col>
                    {dashboard.permissions && dashboard.permissions.edit &&
                        <Col xs={12}>
                            <FormGroup>
                                <Button tag={Link} to={`/dashboard/${dashboard.id}/edit`} color="primary">
                                    Edit
                                </Button>{' '}
                                <Button color="danger" onClick={() => this.deleteDashboard()}>
                                    Delete
                                </Button>
                            </FormGroup>
                        </Col>
                    }
                    <Col xs={12}>
                        {dashboard.tags && dashboard.tags.map(tag => (
                            <Tag key={tag.id} tag={tag} />
                        ))}
                    </Col>
                    <br />
                    <Col xs={12}>
                        {dashboard.iframe_code &&
                            <div class="responsive-inline-frame">
                                <div class="responsive-inline-frame-inner">
                                    <div dangerouslySetInnerHTML={this.createMarkup(dashboard.iframe_code)} />
                                </div>
                            </div>
                        }
                    </Col>
                </Row>
            </div>
        )
    };
}



// WEBPACK FOOTER //
// ./src/pages/Dashboard/index.js